import { useQuery } from '@apollo/client';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { SimplePanel } from '~/components/common/Panel';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { StudyList } from '~/components/upload/study/study-list';
import { useSortFilter } from '~/hooks/data';
import { toSortableStudy } from '~/routes/upload/model/__uploadModelsPage/studies';
import { useUploadRegionUpdatePageContext } from '~/routes/upload/model/region/$regionId';
import { filterUniqueBy } from '~/utils/common';

const UPLOAD_REGION_UPDATE_STUDIES_PAGE = graphql(`
  query UploadRegionUpdateStudiesPage($id: ID!) {
    regionGet(id: $id) {
      id
      outcrops {
        id
        studies {
          ...uploadStudyListParts
        }
      }
    }
  }
`);

export default function UploadRegionStudiesPage() {
  return (
    <ApolloProviderV4>
      <UploadRegionStudiesPageInner />
    </ApolloProviderV4>
  );
}

function UploadRegionStudiesPageInner() {
  const ctx = useUploadRegionUpdatePageContext();
  const regionId = ctx.region.id;

  const { data, loading } = useQuery(UPLOAD_REGION_UPDATE_STUDIES_PAGE, {
    variables: { id: regionId },
  });

  const studies =
    data?.regionGet?.outcrops
      .flatMap(oc => oc.studies)
      .filter(filterUniqueBy(s => s.id))
      .map(toSortableStudy) ?? [];

  const { items, sortIndicatorProps, filterSearchProps } = useSortFilter(
    studies,
    'id',
    'name',
    'uploadRegionStudyList',
  );

  if (loading) {
    return <SpinnerPlaceholder />;
  }

  return (
    <SimplePanel
      title={
        <span>
          Linked Studies{' '}
          <span className="text-muted text-sm">
            ({items.length} results displayed)
          </span>
        </span>
      }
    >
      <StudyList
        studies={items}
        sortIndicatorProps={sortIndicatorProps}
        filterSearchProps={filterSearchProps}
      />
    </SimplePanel>
  );
}
